import { getVisitorId } from '@/utils/tool'
import { ThemeProvider } from '@emotion/react'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { useEffect } from 'react'
import { Toaster } from 'react-hot-toast'
import { HashRouter } from 'react-router-dom'
import { useRecoilState, useRecoilValue } from 'recoil'
import BrowserTips from './components/BrowserTips'
import DeviceTest from './components/DeviceTest'
import Modal from './components/Modal'
import './index.css'
import { AnimatedRoutes } from './router'
import { deviceShowState } from './store/deviceInfo'
import { isDarkState } from './store/theme'
import { darkTheme, lightTheme } from './theme'
dayjs.locale('zh-cn')

export default function Index() {
  const isDark = useRecoilValue(isDarkState)
  const [deviceShow, setDeviceShow] = useRecoilState(deviceShowState)

  useEffect(() => {
    console.info(`%c Version %c ${import.meta.env.VITE_APP_TIME} `, 'color: #fff; background: #5f5f5f', 'color: #fff; background: #4bc729')

    getVisitorId()
    if (import.meta.env.VITE_APP_ENV !== 'dev') {
      // 方式一：普通上报，上报资源加载情况、报错、promise报错、网络情况
      // new ReportLog({
      //   project: 'msb-teacher-website-' + import.meta.env.VITE_APP_ENV, // 必填 应用名称，取项目名即可，如果需要区分环境，可以使用project-env，也可以只上报线上环境
      //   logging: false,
      //   url: import.meta.env.VITE_APP_SOCKET_URL,
      //   cdn: {
      //     socket: 'https://imgvip.meishubao.com/js/socket.io.min.js',
      //     protobuf: 'https://imgvip.meishubao.com/js/protobuf.min.js'
      //   }
      // })
    }
  }, [])

  return (
    <ThemeProvider theme={isDark ? darkTheme : lightTheme}>
      <HashRouter>
        {/* 设备检测 */}
        <Modal show={deviceShow} shadowClick={false} header="" footer="" cancel={() => setDeviceShow(false)} style={{ padding: 0 }}>
          <DeviceTest fromPage={''} cancel={() => setDeviceShow(false)} />
        </Modal>

        {/* 路由 */}
        <AnimatedRoutes />
      </HashRouter>

      <BrowserTips />

      {/* 全局提示 */}
      <Toaster />
    </ThemeProvider>
  )
}
